export const learnMoreLink = 'https://support.approvalmax.com/portal/en/kb/articles/line-item-xero-accrual-reports';
